import React from "react";
import * as styles from "/src/components/Project/Dots.module.css";

const Dots = (props) => {
  return (
    <div
      role={"none"}
      className={`${styles.dot} ${props.active ? styles.active : null}`}
      onClick={props.onPress}
    ></div>
  );
};

export default Dots;
